import {
  Box,
  Divider,
  DialogContentText,
  type BoxProps,
  type DividerProps,
  type DialogContentTextProps,
} from "@mui/material";
import { ReactNode } from "react";

interface FormSectionProps {
  title: string;
  children: ReactNode;
  columns?: number;
  direction?: BoxProps["flexDirection"];
  wrap?: boolean;
  containerProps?: BoxProps;
  fieldContainerProps?: BoxProps;
  dividerProps?: DividerProps;
  titleProps?: DialogContentTextProps;
}

const FormSection = ({
  title,
  direction = "row",
  wrap = true,
  columns = 1,
  children,
  containerProps,
  fieldContainerProps,
  dividerProps,
  titleProps,
}: FormSectionProps) => {
  return (
    <Box
      marginY={2}
      {...containerProps}
      sx={{
        // Ensures we aren't doubling margins on the first element
        "&:first-of-type": {
          marginTop: 0,
        },
        ...containerProps?.sx,
      }}
    >
      <DialogContentText margin={0} {...titleProps}>
        {title}
      </DialogContentText>
      <Divider
        sx={{
          opacity: ".25",
          borderColor: "black",
          margin: 0,
          marginBottom: 1,
        }}
        variant="fullWidth"
        {...dividerProps}
      />
      <Box
        display="flex"
        gap={2}
        padding={1}
        flexDirection={direction}
        flexWrap={wrap ? "wrap" : "nowrap"}
        {...fieldContainerProps}
        sx={{
          "& > *": {
            // This lets us pass a number of columns we want into the parent
            // and calculate the flex basis from that
            // NOTE: if you want to override this property (for instance if not all cols are equal)
            // you will need to use the following syntax
            // sx={{ "&": { flex: "2 2 50%" } }}
            // Take note of the "&" in the selector. If you don't have that there this rule will take precedence
            flex: `1 1 calc(${100 / columns}% - 2em)`,
          },
          ...fieldContainerProps?.sx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
export default FormSection;
